import React, { Fragment } from 'react';
import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Img from "react-cool-img";
import mime from 'mime';
import { useTranslation } from 'react-i18next/hooks';

import GroupTextItemReplyOriDetail from './GroupTextItemReplyOriDetail';

import { useStore } from '../../../../../hook-store/store';
import { getDateTime } from '../../../../../util/timeFormat';
// import { scrollToTextListRefItem } from '../../../../util/group/group-text-list';
// import { isImageFile, isVideoFile, isAudioFile } from '../../../../util/image';

import { marks } from '../../../../../images/marks';
import classes from './GroupTextItemReplyOri.module.css';

import SampleImage from "../../../../Image/person-icon-50.jpg";

const GroupTalkTextItemReplyOri = (props) => {
  // console.log('GroupTalkTextItem-props', props);

  const { 
    inputData, 
    userId, 
    allMemberUserIds,
    lsNameDataList,
   } = props;


  const [t] = useTranslation('translation');

  const [store, dispatch] = useStore();
  const {
    selectedGroupData,
    // groupTextItemRef,
  } = store.groupStore;
  // console.log('store in GroupTalkTextItem', store);

  const [showReplyOriModal, setShowReplyOriModal] = useState(false);


  // let userImageSrc;
  // if (store.groupMemberImageUrls && store.groupMemberImageUrls.length > 0) {
  //   const userImageUrl = store.groupMemberImageUrls.find(iurl => {
  //     return iurl.userId === inputData.fromUserId;
  //   });

  //   if (userImageUrl) {
  //     userImageSrc = userImageUrl.imageUrl;
  //   }
  // }
  // console.log('userImageSrc', userImageSrc, inputData)


  // console.log(groupTalkInputList);
  let elementStyle = "textTalk-listElement-remote";
  let colorStyle = null;

  if (inputData.fromUserId === userId) {
    elementStyle = "textTalk-listElement-local"
    colorStyle={ 
      color: 'var(--color)',
      border: '0.5px solid lightgray',
     }
  }

  // console.log('allMemberUserIds', allMemberUserIds);
  if (inputData.fromUserId !== userId && allMemberUserIds.length > 0
  ) {
    const userColorElement = allMemberUserIds.find(element => {
      return element.userId === inputData.fromUserId;
    });
    // console.log('userColorElement', userColorElement, inputData.fromUserId);
    
    if (userColorElement) {
      colorStyle = {
        // color: 'black', 
        // backgroundColor: userColorElement.bgColor,
        border: `1px solid ${userColorElement.userColor}`,
      };
    } else {
      colorStyle = {
        // color: 'black', 
        // backgroundColor: userColorElement.bgColor,
        border: `1px solid lightgray`,
      };
    }
  }



    // const lsDarkMode = localStorage.getItem('darkMode');
    // if (lsDarkMode) {
    //   colorStyle = null;
    // }

    // console.log('darkMode, colorStyle', localStorage.getItem('darkMode'), colorStyle);
    // console.log('userColor[0]', userColorList[0].bgColor);
  const sendTime = new Date(inputData.sendAt);

  let [month, date, year] = (new Date(inputData.sendAt)).toLocaleDateString().split("/")
  let [hour, minute, second] = (new Date(inputData.sendAt)).toLocaleTimeString().slice(0, 7).split(":")
  let xm = (new Date(inputData.sendAt)).toLocaleTimeString().split(' ')[1];
  




  let replyOriInputData;
  let replyOriNameData;

  if (inputData && inputData.replyInfo && inputData.replyInfo.originalTextId &&
    selectedGroupData
  ) {
    replyOriInputData = selectedGroupData.talks?.find(element => {
      return element._id === inputData.replyInfo.originalTextId;
    });

    if (replyOriInputData && lsNameDataList && JSON.parse(lsNameDataList).length > 0) {
        replyOriNameData = JSON.parse(lsNameDataList).find(ele => {
          return ele.userId === replyOriInputData.fromUserId;
        });
    }
    // console.log('replyOriginalData', replyOriInputData)
    // console.log('replyOriNameData', replyOriNameData)
  }


  let fileMime;

  if (replyOriInputData && replyOriInputData.filePaths && replyOriInputData.filePaths.length > 0) {
    fileMime = mime.getType(replyOriInputData.filePaths[0]);
    // console.log(fileMime)
    // if (fileMime && fileMime.split('/')[0] === 'audio') {
    //   oriFileContent = (
    //     <span>{marks.fileAudio}</span>
    //   )

  }

  if (replyOriInputData && replyOriInputData.kuraFileInfo && replyOriInputData.kuraFileInfo.mimeType) {
    fileMime = replyOriInputData.kuraFileInfo.mimeType;
  }




  let oriTextContent;

  if (replyOriInputData && replyOriInputData.text) {
    if (replyOriInputData.text.length > 50) {
      oriTextContent = replyOriInputData.text.slice(0,50) + '...';
    } else {
      oriTextContent = replyOriInputData.text;
    }
  }



  

  let groupTextItemReplyOriBody;

  //// original post not exist case.
  if (inputData && inputData.replyInfo && inputData.replyInfo.originalTextId && !replyOriInputData) {
    groupTextItemReplyOriBody = (
      <div className={classes.groupTextItemReplyOri}>
        <div 
          className={classes.groupTextItemReplyOriContent}
          style={{color: "gray"}}
        >
            Original post not found...
        </div>
      </div>
    );
  }

  if (replyOriInputData || replyOriNameData) {
    groupTextItemReplyOriBody = (
      <div className={classes.groupTextItemReplyOri}>
        <div className={classes.groupTextItemReplyOriContent}
          // style={{border:"1px solid gray", padding: "0.5rem"}}
          onClick={() => {
            setShowReplyOriModal(true);
            // scrollToOriTextHandler();
          }}
        >
          {/* <div>
            original-text
          </div> */}
          {replyOriInputData && (
            <div className={classes.groupTextItemReplyOriRow}>
              <div>
                {oriTextContent}
                {' '}
                {fileMime && (
                  <span>{marks.fileMark}</span>
                )}
              </div>
            </div>
          )}

          {replyOriNameData && (
            <div className={classes.groupTextItemReplyOriUserRow}>
              {replyOriNameData.name}
              {replyOriNameData.imageUrl && (
                <Img style={{height: "1.25rem", width:"1.25rem", objectFit: "cover"}}
                  src={replyOriNameData.imageUrl}
                />
              )}
              {!replyOriNameData.imageUrl && (
                <Img style={{height: "1.25rem", width:"1.25rem", objectFit: "cover"}}
                  src={SampleImage}
                />
              )}
            </div>
          )}

          {replyOriInputData && (
            <div className={classes.groupTextItemReplyOriTime}
            >
              {getDateTime(replyOriInputData.sendAt)}
            </div>
          )}
        </div>
      </div>
    );
  }


 
  return (
    <Fragment>
      {groupTextItemReplyOriBody}

      {showReplyOriModal && (
        <div>
          <GroupTextItemReplyOriDetail 
            inputData={inputData}
            showReplyOriModal={showReplyOriModal}
            setShowReplyOriModal={setShowReplyOriModal}
            replyOriInputData={replyOriInputData}
            replyOriNameData={replyOriNameData}
            fileMime={fileMime}
            lsNameDataList={lsNameDataList}
          />
        </div>
      )}
    </Fragment>
  );
}

export default GroupTalkTextItemReplyOri;